/** All user-visible strings in one place for easy localisation. */
const i18n = {
  appTitle: 'New Task',
  labelTitle: 'Title',
  placeholderTitle: 'What needs to be done?',
  labelAssignee: 'Assignee',
  optionUnassigned: 'Unassigned',
  labelPriority: 'Priority',
  optionPriorityDefault: '— No priority —',
  priorities: {
    urgent: '🔴 Urgent',
    high: '🟠 High',
    normal: '🟡 Normal',
    low: '🔵 Low',
  } as const,
  labelDueDate: 'Due date',
  labelDescription: 'Description',
  placeholderDescription: 'Optional description…',
  labelSubtasks: 'Subtasks',
  placeholderSubtask: 'Subtask…',
  addSubtask: '+ Add subtask',
  removeSubtask: '×',
  mainButtonCreate: 'Create Task',
  loadingMembers: 'Loading…',
  errorLoadMembers: 'Could not load members. Tap to retry.',
  errorCreateTask: 'Failed to create task. Please try again.',
  successTitle: 'Task created!',
  successSubtitle: 'Closing…',
} as const;

export default i18n;
